var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Widget.CartWidget = 'CartWidget';
	Vendd.Widget.WishlistWidget = 'WishlistWidget';
	Vendd.Widget.WishlistArticleWidget = 'WishlistArticleWidget';
	Vendd.Widget.LoginWidget = 'LoginWidget';
	Vendd.Widget.ProductCompareWidget = 'ProductCompareWidget';
	
	return Vendd;

})(Vendd || {});
